import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import {
  MOBILE_SCREEN_WIDTH,
  TAB_SCREEN_WIDTH,
} from "../../../utils/constants";
import { useNationalLeagueStore } from "../../../store/StoreContext";
import { useFontDesk } from "../../../context/frontDeskContext";
import { MatchCard } from "../../matchList/widgets/MatchCard";

type props = {};

export const AllNationalLeagueMatches: React.FC<props> = observer(() => {
  const nationalLeagueStore = useNationalLeagueStore();
  const { isMobile, isTab, setIsMobile, setIsTab } = useFontDesk();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_SCREEN_WIDTH);
      setIsTab(window.innerWidth < TAB_SCREEN_WIDTH && !isMobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, setIsMobile, setIsTab]);

  return (
    <>
      {nationalLeagueStore.leagueMatches.length === 0 &&
        !nationalLeagueStore.isLeagueMatchesLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ marginTop: "50%" }}>
            <p
              className="text-center"
              style={{ fontSize: "1.2rem", textAlign: "center" }}>
              No matches found
            </p>
          </div>
        )}
      <div
        // ref={listRef}
        // onScroll={handleScroll}
        style={{
          marginTop: 20,
          display: isMobile ? "flex" : "grid",
          gridTemplateColumns: (() => {
            if (isMobile) return "1fr";
            if (isTab) return "repeat(1, 1fr)";
            // desktop
            return nationalLeagueStore.leagueMatches.length === 1
              ? "1fr"
              : "repeat(2, 1fr)";
          })(),
          gap: isMobile ? "25px" : "25px 25px", // row-gap 15px, column-gap 25px for desktop
          flexDirection: isMobile ? "column" : undefined,
          padding: "0 16px",
          width: "100%",
          overflowY: "auto",
        }}>
        {nationalLeagueStore.leagueMatches.map((league, idx) => {
          const isSingleCentered =
            !isMobile && nationalLeagueStore.leagueMatches.length === 1;
          return (
            <div
              key={league.id}
              style={{
                maxWidth: isSingleCentered ? 800 : "100%",
                margin: isSingleCentered ? "0 auto" : undefined,
                width: "100%",
              }}>
              {/* <Match key={league.id} match={league} /> */}
              <MatchCard match={league} isLeagueMatch />
            </div>
          );
        })}
      </div>
    </>
  );
});
